export default "__VITE_ASSET__a55960fc__"